import { render, staticRenderFns } from "./appSelect.vue?vue&type=template&id=4b851b22&"
import script from "./appSelect.vue?vue&type=script&lang=js&"
export * from "./appSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports